import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "count"];
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';
var BadgeIndicator = /*#__PURE__*/React__default.forwardRef(function BadgeIndicatorContent(_ref, ref) {
  var customClassName = _ref.className,
    count = _ref.count,
    rest = _objectWithoutProperties(_ref, _excluded);
  var prefix = usePrefix();
  var classNames = cx("".concat(prefix, "--badge-indicator"), customClassName, _defineProperty({}, "".concat(prefix, "--badge-indicator--count"), count));
  var displayCount = count && count > 999 ? '999+' : count;
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classNames,
    ref: ref
  }, rest), displayCount);
});
BadgeIndicator.propTypes = {
  /**
   * Specify an optional className to add.
   */
  className: PropTypes.string,
  /**
   * Count of badge indicator
   */
  count: PropTypes.number,
  /**
   * Provide an `id` to uniquely identify the BadgeIndidcator
   */
  id: PropTypes.string
};
export { BadgeIndicator, BadgeIndicator as default };